/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import BookmakerRegPanelContainer, { BookmakerRegPanel } from './BookmakerRegPanel';

/**
 * Bookmakers module exports
 */
export {
    BookmakerRegPanel,
    BookmakerRegPanelContainer as default
};



// WEBPACK FOOTER //
// ./src/js/BookmakerRegPanel/index.js